import { Stage } from "views/settings-crm/types/stage";

export const sortStagesByOrder = (
  stages: Stage[],
  order: string[] | null | undefined
): Stage[] => {
  if (!order?.length) return stages;

  const rankById = new Map(order.map((id, index) => [id, index]));
  const rankOf = (stage: Stage) =>
    rankById.get(String(stage.id)) ?? Number.MAX_SAFE_INTEGER;

  return [...stages].sort((a, b) => rankOf(a) - rankOf(b));
};

interface MoveStageInOrderInput {
  allOrderedIds: string[];
  visibleOrderedIds: string[];
  from: number;
  to: number;
}

export const moveStageInOrder = ({
  allOrderedIds,
  visibleOrderedIds,
  from,
  to
}: MoveStageInOrderInput): string[] => {
  const nextVisibleIds = [...visibleOrderedIds];
  const [movedId] = nextVisibleIds.splice(from, 1);
  if (!movedId) return allOrderedIds;
  nextVisibleIds.splice(to, 0, movedId);

  const remainingIds = allOrderedIds.filter((id) => id !== movedId);

  const precedingId = to > 0 ? nextVisibleIds[to - 1] : undefined;
  const precedingAnchor = precedingId ? remainingIds.indexOf(precedingId) : -1;
  if (precedingAnchor !== -1)
    return [
      ...remainingIds.slice(0, precedingAnchor + 1),
      movedId,
      ...remainingIds.slice(precedingAnchor + 1)
    ];

  const followingId = nextVisibleIds[to + 1];
  const followingAnchor = followingId ? remainingIds.indexOf(followingId) : -1;
  if (followingAnchor !== -1)
    return [
      ...remainingIds.slice(0, followingAnchor),
      movedId,
      ...remainingIds.slice(followingAnchor)
    ];

  return [movedId, ...remainingIds];
};
